import { rewardDeductAmt } from '@/api/cashier'
import { detail } from '@/api/member/types'
import { list as memberDayList } from '@/api/member/day'
const state = () => ({
  cashierMember: null,
  rewardDeduct: null,
})
const getters = {
  cashierMember: (state) => state.cashierMember,
  rewardDeduct: (state) => state.rewardDeduct,
}
const mutations = {
  setCashierMember(state, cashierMember) {
    state.cashierMember = cashierMember
  },
  setRewardDeduct(state, rewardDeduct) {
    state.rewardDeduct = {
      ...rewardDeduct,
      baseUseRewardDeductAmt: rewardDeduct?.useRewardDeductAmt
    }
  },
}
const actions = {
  async setCashierMember({ commit }, cashierMember) {
    if (!cashierMember) return commit('setCashierMember', null)
    const { data: typeDetail } = await detail(cashierMember.memberTypeId)
    let discountRatio = typeDetail.discountRatio
    const { data } = await memberDayList({ statusList: ['EFFECTIVE'] })
    // console.log('TIPS setCashierMember:',data)
    if (data) {
      let memberDayDetail = data
      const currentTime = dayjs().valueOf()
      // dayjs().day() 为 0-6（0=周日），与会员日 weekEnum（周日为 7）一致需将 0 映射为 7，同 localDB 单品促销判定
      const weekdayJs = dayjs().day()
      const currentWeek = String(weekdayJs === 0 ? 7 : weekdayJs)
      const currentDay = dayjs().date().toString()
      const isInRange = currentTime >= memberDayDetail.activityBegin && currentTime <= memberDayDetail.activityEnd
      if (isInRange) {
        if (memberDayDetail.activityCycleType === 'WEEK') {
          if (memberDayDetail.activityCycleSetting.split(',').includes(currentWeek)) {
            discountRatio = memberDayDetail.discountRatio
          }
        } else {
          if (memberDayDetail.activityCycleSetting.split(',').includes(currentDay)) {
            discountRatio = memberDayDetail.discountRatio
          }
        }
      }
    }
    cashierMember = {
      ...cashierMember,
      discountRatio,
      basePrice: typeDetail.basePrice,
      rewardRatio: typeDetail.rewardRatio,
      ifReward: typeDetail.ifReward,
      memberTypeName: typeDetail.memberTypeName,
    }
    commit('setCashierMember', cashierMember)
  },
  removeCashierMember({ commit }) {
    commit('setCashierMember', null)
    commit('setRewardDeduct', null)
  },
  async fetchRewardDeduct({ commit, state }, payload) {
    if (!state.cashierMember) return commit('setRewardDeduct', null)
    const { data } = await rewardDeductAmt({ ...payload, memberInfoId: state.cashierMember.memberInfoId })
    commit('setRewardDeduct', data)
  },
}
export default { state, getters, mutations, actions }
